// extracted by mini-css-extract-plugin
export default {"byDateWrapper":"styles_byDateWrapper__XGjXN","notificationsByDate":"styles_notificationsByDate__QOaJw","title":"styles_title__-pgNB","part":"styles_part__aJzdW"};